import axios from './axiosConfig'; // Assuming you have a configured axios instance like in complianceActions

// Define API_URL (adjust if your asset API is different from compliance)
const API_URL = process.env.NODE_ENV === 'production' 
    ? "https://api.test.raborisk.ai" 
    : "http://localhost:3000";

// Action Types
export const GET_ASSETS = 'GET_ASSETS';
export const ASSETS_REQUEST = 'ASSETS_REQUEST';
export const ASSETS_STATS_REQUEST = 'ASSETS_STATS_REQUEST';
export const ADD_ASSET = 'ADD_ASSET';
export const EDIT_ASSET = 'EDIT_ASSET';
export const DELETE_ASSET = 'DELETE_ASSET';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const GET_USERS = 'GET_USERS';
export const SET_USERS = 'SET_USERS';
export const ASSETS_DATA = 'ASSETS_DATA';
export const SET_LOCATIONS = 'SET_LOCATIONS';

const assetsScopeKey = (scopeType, scopeId) => `${scopeType}:${scopeId ?? 0}`;

// Action Creators
export const getInventory = (departmentId = null) => {
  const scopeKey = assetsScopeKey("dept", departmentId);
  return async (dispatch) => {
    dispatch({ type: ASSETS_REQUEST, scopeKey });

    try {
      const response = await axios.get(
        `${API_URL}/api/assets/get_inventory`,
        {
          params: departmentId ? { department_id: departmentId } : {}
        }
      );

      dispatch({
        type: GET_ASSETS,
        payload: response.data,
        scopeKey,
      });
    } catch (error) {
      dispatch({
        type: SET_ERROR,
        payload: error.response?.data?.message || "Failed to fetch assets"
      });
    }
  };
};


export const getInventoryComp = (compId = null) => {
  const scopeKey = assetsScopeKey("comp", compId);
  return async (dispatch) => {
    dispatch({ type: ASSETS_REQUEST, scopeKey });

    try {
      const response = await axios.get(
        `${API_URL}/api/assets/get_inventory`,
        {
          params: compId ? { compliance_id: compId } : {}
        }
      );

      dispatch({
        type: GET_ASSETS,
        payload: response.data,
        scopeKey,
      });
    } catch (error) {
      dispatch({
        type: SET_ERROR,
        payload: error.response?.data?.message || "Failed to fetch assets"
      });
    }
  };
};

export const addAsset = (assetData) => {
    return async (dispatch) => {
        dispatch({ type: SET_LOADING });
        try {
            // Use API_URL
            ////console.log("assetData ", assetData)
            const response = await axios.post(`${API_URL}/api/assets/add_asset`, assetData);
            dispatch({
                type: ADD_ASSET,
                payload: response.data
            });
            return response.data;
        } catch (error) {
            dispatch({
                type: SET_ERROR,
                payload: error.response?.data?.message || 'Failed to add asset'
            });
            throw error;
        }
    };
};

export const duplicateAsset = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING });
    try {
      const response = await axios.post(`${API_URL}/api/assets/duplicate_asset/${id}`);

      

      return response.data;
    } catch (error) {
      dispatch({
        type: SET_ERROR,
        payload: error.response?.data?.message || "Failed to duplicate asset"
      });
      throw error;
    }
  };
};


export const editAsset = (id, assetData) => {
  //console.log(assetData)
    return async (dispatch) => {
        dispatch({ type: SET_LOADING });
        try {
            // Use API_URL
            const response = await axios.put(`${API_URL}/api/assets/edit_asset/${id}`, assetData);
            dispatch({
                type: EDIT_ASSET,
                payload: response.data
            });
            return response.data;
        } catch (error) {
            dispatch({
                type: SET_ERROR,
                payload: error.response?.data?.message || 'Failed to edit asset'
            });
            throw error;
        }
    };
};

// add dependency (draw mode)
export const addDependency = (assetId, dependsOnId) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING });
    try {
      const response = await axios.post(
        `${API_URL}/api/assets/${assetId}/dependencies`,
        { dependsOnId }
      );

      return response.data;
    } catch (error) {
      dispatch({
        type: SET_ERROR,
        payload: error.response?.data?.message || "Failed to add dependency",
      });
      throw error;
    }
  };
};

// delete dependency (delete mode)
export const deleteDependency = (assetId, dependsOnId) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADING });
    try {
      const response = await axios.delete(
        `${API_URL}/api/assets/${assetId}/dependencies`,
        { data: { dependsOnId } } // ✅ axios delete body
      );


      return response.data;
    } catch (error) {
      dispatch({
        type: SET_ERROR,
        payload: error.response?.data?.message || "Failed to delete dependency",
      });
      throw error;
    }
  };
};


export const deleteAsset = (id) => {
    return async (dispatch) => {
        dispatch({ type: SET_LOADING });
        ////console.log("ID ", id)
        try {
            await axios.delete(`${API_URL}/api/assets/delete_asset/${id.id}`);
            dispatch({
                type: DELETE_ASSET,
                payload: id
            });
        } catch (error) {
            dispatch({
                type: SET_ERROR,
                payload: error.response?.data?.message || 'Failed to delete asset'
            });
        }
    };
};


export const getAssetStats = (departmentId = null) => {
  const scopeKey = assetsScopeKey("dept", departmentId);
  return async (dispatch) => {
    dispatch({ type: ASSETS_STATS_REQUEST, scopeKey });

    try {
      const response = await axios.get(
        `${API_URL}/api/assets/get_asset_stats`,
        {
          params: departmentId ? { department_id: departmentId } : {}
        }
      );

      dispatch({
        type: ASSETS_DATA,
        payload: response.data,
        scopeKey,
      });
    } catch (error) {
      console.error("Failed to fetch asset stats:", error);
    }
  };
};

export const getAssetStatsComp = (compId = null) => {
  const scopeKey = assetsScopeKey("comp", compId);
  return async (dispatch) => {
    dispatch({ type: ASSETS_STATS_REQUEST, scopeKey });

    try {
      const response = await axios.get(
        `${API_URL}/api/assets/get_asset_stats`,
        {
          params: compId ? { compliance_id: compId } : {}
        }
      );

      dispatch({
        type: ASSETS_DATA,
        payload: response.data,
        scopeKey,
      });
    } catch (error) {
      console.error("Failed to fetch asset stats:", error);
    }
  };
};



export const getLocations = (departmentId) => {
    return async (dispatch) => {
        if (!departmentId) return;
        try {
            const response = await axios.get(`${API_URL}/api/assets/get_locations`, {
                params: { department_id: departmentId }
            });
            dispatch({ type: SET_LOCATIONS, payload: response.data });
        } catch (error) {
            dispatch({ type: SET_ERROR, payload: error.response?.data?.message || 'Failed to fetch locations' });
        }
    };
};

export const addLocation = (name, departmentId) => {
    return async (dispatch) => {
        if (!departmentId) return;
        try {
            const response = await axios.post(`${API_URL}/api/assets/add_location`, { name, department_id: departmentId });
            dispatch({ type: SET_LOCATIONS, payload: response.data });
        } catch (error) {
            dispatch({ type: SET_ERROR, payload: error.response?.data?.message || 'Failed to add location' });
        }
    };
};

export const deleteLocation = (id, departmentId) => {
    return async (dispatch) => {
        try {
            const response = await axios.post(`${API_URL}/api/assets/delete_location`, { id, department_id: departmentId });
            dispatch({ type: SET_LOCATIONS, payload: response.data });
        } catch (error) {
            dispatch({ type: SET_ERROR, payload: error.response?.data?.message || 'Failed to delete location' });
        }
    };
};

export const getUsers = () => {
    // No SET_LOADING here — this only feeds the overlay's owner picker and
    // fires on every overlay open; sharing the list's loading flag was
    // flickering the asset list/table underneath.
    return async (dispatch) => {
        try {
            const response = await axios.get(`${API_URL}/api/admin/get_users`);
            dispatch({
                type: SET_USERS,
                payload: response.data
            });
        } catch (error) {
            dispatch({
                type: SET_ERROR,
                payload: error.response?.data?.message || 'Failed to fetch users'
            });
        }
    };
};

export const updateAssetPosition = (id, map_x, map_y) => async () => {
    try {
        await axios.post(`${API_URL}/api/assets/update_position`, { id, map_x, map_y });
    } catch (err) {
        console.error('Failed to save asset position', err);
    }
};

export const resetAssetPositions = (department_id, compliance_id) => async () => {
    try {
        await axios.post(`${API_URL}/api/assets/reset_positions`, { department_id, compliance_id });
    } catch (err) {
        console.error('Failed to reset asset positions', err);
    }
};

export const fetchAssetRisks = (assetId) => async () => {
    try {
        const { data } = await axios.get(`${API_URL}/api/assets/asset_risks/${assetId}`);
        return Array.isArray(data) ? data : [];
    } catch (err) {
        console.error('Error fetching asset risks:', err);
        throw err;
    }
};

export const linkAssetRisk = (assetId, riskId) => async () => {
    const { data } = await axios.post(`${API_URL}/api/assets/link_risk`, {
        asset_id: assetId,
        risk_id: riskId,
    });
    return Array.isArray(data) ? data : [];
};

export const unlinkAssetRisk = (assetId, riskId) => async () => {
    const { data } = await axios.post(`${API_URL}/api/assets/unlink_risk`, {
        asset_id: assetId,
        risk_id: riskId,
    });
    return Array.isArray(data) ? data : [];
};

export const searchRisksForAssetLink = ({
    departmentId = null,
    complianceId = null,
    q = '',
    page = 1,
    pageSize = 20,
    excludeAssetId = null,
}) => async () => {
    const params = { q, page, pageSize };
    if (complianceId) params.compliance_id = complianceId;
    else if (departmentId) params.department_id = departmentId;
    if (excludeAssetId) params.exclude_asset_id = excludeAssetId;

    const { data } = await axios.get(`${API_URL}/api/assets/search_risks_for_link`, { params });
    return data;
};

export const searchAssetsForLink = ({
    departmentId = null,
    complianceId = null,
    q = '',
    page = 1,
    pageSize = 20,
    excludeRiskId = null,
    category = null,
}) => async () => {
    const params = { q, page, pageSize };
    if (complianceId) params.compliance_id = complianceId;
    else if (departmentId) params.department_id = departmentId;
    if (excludeRiskId) params.exclude_risk_id = excludeRiskId;
    if (category) params.category = category;

    const { data } = await axios.get(`${API_URL}/api/assets/search_assets_for_link`, { params });
    return data;
};
